
<div class="border-div margin0 min-heightcontainer">
    <div class="floatinghead clearfix">
        <h2 class="mainhead "><span class="text">Duplicate Properties</span></h2>
        <div class="rightside clearfix">
        </div>
    </div>
    <div class="table-responsive">
        <table class="table basictable row-border hover" id="dtTableDuplicates" datatable [dtOptions]="dtOptions">
            <tbody>
                <tr *ngFor="let prop of duplicatePropertyList;let i = index ">
                    <td>
                        <ul class="connection-list brokerlist be-exchange-list">
                            <li class="clearfix">
                                <div class="right">
                                  <h6>
                     
                                    <a href="javascript:void(0);" *ngIf="prop.Type == 1" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.PropertyGuid}}" [queryParams]="{prevroute:'Property Details',link:routeURL}">{{prop.TenantName}}</a>
                                    <a href="javascript:void(0);" *ngIf="prop.Type == 2" routerLink="/viewdeproperty/{{prop.Slug ? prop.Slug : prop.PropertyGuid}}" [queryParams]="{prevroute:'Property Details',link:routeURL}">{{prop.TenantName}}</a>
                                  </h6>
                                    <p>
                                        {{prop.State}},{{prop.City}}
                                    </p>
                                    <p>
                                        <span class="tag" [ngClass]="{'greentext':prop.Type == 1,'ashtext':prop.Type == 2 }">
                                            {{prop.Status}}
                                        </span>
                                    </p>
                                </div>
                            </li>
                        </ul>

                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr *ngIf="duplicatePropertyList?.length == 0 ">
                    <td colspan="15" class="odd no-data-available">
                        <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Duplicates</p>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
